export default __webpack_public_path__ + "static/media/AM2 Logo Horizontal Colour Light.a759c227.png";